var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import classNames from 'classnames';
export var Checkbox = React.forwardRef(function (_a, ref) {
    var children = _a.children, hiddenLabel = _a.hiddenLabel, _b = _a.inline, inline = _b === void 0 ? true : _b, noMargins = _a.noMargins, id = _a.id, checked = _a.checked, rest = __rest(_a, ["children", "hiddenLabel", "inline", "noMargins", "id", "checked"]);
    var generatedId = useId();
    var inputId = id !== null && id !== void 0 ? id : generatedId;
    var labelProps = {
        className: classNames({
            'ffe-checkbox': true,
            'ffe-checkbox--inline': inline,
            'ffe-checkbox--no-margin': noMargins,
            'ffe-checkbox--hidden-label': hiddenLabel,
        }),
        htmlFor: inputId,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", __assign({ ref: ref, className: "ffe-hidden-checkbox", id: inputId, type: "checkbox", checked: checked }, rest)),
        typeof children === 'function' ? (children(labelProps)) : (
        // eslint-disable-next-line jsx-a11y/label-has-for
        React.createElement("label", __assign({}, labelProps),
            React.createElement("span", { className: classNames('ffe-checkbox__content', {
                    'ffe-screenreader-only': hiddenLabel,
                }) }, children)))));
});
